module.exports = __webpack_public_path__ + "img/imgVideo.50cd9884.png";